import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/node_modules/.pnpm/next@14.2.35_@babel+core@7.26.10_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/src/assets/images/convention/2025scholarship/section-0.png");
;
import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/src/assets/images/convention/2025scholarship/section-1.png");
;
import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/src/assets/images/convention/2025scholarship/section-2.png");
;
import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/src/assets/images/convention/2025scholarship/section-3.png");
